<template>
    <div id="container" :class="['sub-container']">
        <PulseLoader :loading="this.loading" />
        <div class="container_inner">
            <div class="sc04d">
                <h3><b class="tit-st tit-st01"></b>&nbsp;&nbsp;공공데이터</h3>
                <div class="sub_txt pdl-24">분야별 연계정보. 강남 데이터를 알기 쉽게!
                </div>
                <div class="search-form2" style="z-index: 90;" v-if="$_WC.viewScale < 2">
                    <input type="text" class="search-input" autocomplete="off" id="" name="" title="검색어 입력" placeholder="검색어를 입력하세요" v-model="searchVal" @keyup.enter="searchOpenapiList()">
                    <button type="submit" title="검색" class="search-btn"  @click.prevent="searchOpenapiList()"><i class="search-icon"></i> <span>검색</span></button>
                </div>
                <span v-if="!$_WC.isMobile && $_WC.viewScale == 1">&nbsp;(각 데이터는 제공처가 따로 있으며, 해당 데이터에 대한 문의는 제공처로 해주시길 바랍니다.)</span>
                <OpenapiDataTab />
                <template v-if="selectedOpenApiTab === '01'">
                    <OpenapiTab />
                    <OpenapiList />
                </template>
                <template v-if="selectedOpenApiTab === '02'">
                    <OpenapiErrorReport />
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import OpenapiDataTab from "@/views/openapi/OpenapiDataTab";
import OpenapiTab from "@/views/openapi/OpenapiTab";
import OpenapiList from "@/views/openapi/OpenapiList";
import OpenapiErrorReport from "@/views/openapi/OpenapiErrorReport";
import { $_WC } from '@/confs/common.const.js';
import PulseLoader from "@/views/common/PulseLoader.vue";

export default {
    data() {
        return {
            loading: false,
            searchVal: "",
        }
    },
    components: {
        OpenapiDataTab,
        OpenapiTab,
        OpenapiList,
        OpenapiErrorReport,
        PulseLoader,
    },
    computed: {
        ...mapGetters({
            selectedOpenApiTab: 'getSelectedOpenApiTab',
        }),
    },
    created() {
        if(typeof this.$route.query['code'] !== 'undefined' && this.$route.query['code'].trim() !== '') {
            this.code = this.$route.query['code'];
        } else {
            this.code = '01';
        }
        this.selectOpenApiTab(this.code);
        // url 파라미터 제거(제거할 경우 새로고침 시 분야별 데이터 선택됨 선택)
        // this.removeParam();
        this.$eventBus.$on('Change::Loader::State', (state) => {
            this.loading = state;
        });
    },
    methods: {
        removeParam() {
            history.replaceState({}, null, location.pathname);
        },
        selectOpenApiTab(code) {
            this.$store.dispatch('SET_SELECTED_OPEN_API_TAB', code);
        },
        searchOpenapiList() {
            if(!!this.searchVal) {
                this.$eventBus.$emit('OpenapiTab::search-openapi', this.searchVal)
            } else {
                this.$eventBus.$emit('OpenapiTab::search-openapi', "");
            }
        },
    },
};
</script>
